import React from "react";
import {Chip} from "@mui/material";

export default function AudienceVersionOld({audience}) {

    const titles = {}

    const getTitle = (param) => {
        if (titles.hasOwnProperty(param)) return titles[param];
        return param;
    }

    const getLabel = () => (
        <>
            {audience.from != null &&
                <>
                    {getTitle(audience.parameter)}&nbsp;
                    {(audience.fromIncluded === true || audience.fromIncluded === null) ? '>=' : '>'}&nbsp;{audience?.from?.version}
                </>
            }
            {(audience.to != null && audience?.to?.version !== '' && audience.from!=null && audience?.from?.version=='') && <>; </>}
            {(audience.to != null && audience?.to?.version !== '') &&
                <>
                    {getTitle(audience.parameter)}&nbsp;
                    {audience.toIncluded ? '<=' : '<'}&nbsp;
                    {audience.to != null ? audience?.to?.version : '∞'}
                </>
            }
        </>
    )

    return (
        <Chip label={getLabel()}/>

    )

}